'use client';

import { EmblaCarouselType } from 'embla-carousel';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { reviewsSlides } from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import { Carousel } from '@/app/_componentsv2/carousels/carousel';
import { CarouselNav } from '@/app/_componentsv2/carousels/carousel-nav';
import { DetailedProject } from '@/domain/project/types';

import { ReviewCard } from './review-card';

interface ReviewsProps {
  project: Pick<DetailedProject, 'reviews' | 'name'>;
}

export function Reviews({ project: { reviews, name } }: ReviewsProps) {
  const t = useTranslations();

  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType | null>(null);
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (emblaApi === null) {
      return;
    }

    emblaApi.on('select', () => setSelected(emblaApi.selectedScrollSnap()));
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi === null) {
      return;
    }

    emblaApi.scrollTo(selected);
  }, [selected, emblaApi]);

  if (reviews.length === 0) {
    return null;
  }

  return (
    <section id="reviews">
      <h2 data-short="Avis" className="text-3xl font-bold">
        {t('pages.project.reviews.title', { projectName: name })}
      </h2>
      <Carousel
        classNames={{
          slides: reviewsSlides,
        }}
        emblaApiRef={setEmblaApi}
      >
        {reviews.map((review) => {
          const pictureUrl = review.thumbnail ?? '/logo-sowefund.svg';
          return (
            <ReviewCard
              company={review.company}
              content={review.feedback}
              fullname={review.mentor}
              pictureUrl={pictureUrl}
              key={review.mentor}
            />
          );
        })}
      </Carousel>
      <section>
        <CarouselNav
          bullets={reviews.length}
          selected={selected}
          onSelect={setSelected}
        />
      </section>
    </section>
  );
}
